import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * ReportControlEditorService
 *
 * Event bus service for report control value changes.
 * Components trigger events when their values change, and parent components
 * can subscribe to these events to trigger auto-save or other actions.
 */
@Injectable({
  providedIn: 'root'
})
export class ReportControlEditorService {
  private eventsSubject: Subject<EditorEvent> = new Subject();
  events$: Observable<EditorEvent> = this.eventsSubject.asObservable();

  /**
   * Trigger a value changed event
   */
  triggerEvent(): void {
    const event = new EditorEvent('value_changed');
    this.eventsSubject.next(event);
  }
}

export type EditorEventType = 'value_changed';

export class EditorEvent {
  constructor(readonly type: EditorEventType) {}
}
